module.exports = __webpack_public_path__ + "static/media/thebatman.37831503.png";